module.exports = __webpack_public_path__ + "img/prize.eb027b44.svg";